import * as THREE from 'three';

export const cursor = () => {
// Импорт библиотеки Three.js
// Импорт библиотеки Three.js

// // Инициализация сцены, камеры и рендера
// const scene = new THREE.Scene();
// const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
// const renderer = new THREE.WebGLRenderer({ antialias: true });
// renderer.setSize(window.innerWidth, window.innerHeight);
// document.body.appendChild(renderer.domElement);

// // Создание частиц
// const particleGeometry = new THREE.BufferGeometry();
// const particleMaterial = new THREE.PointsMaterial({ size: 0.1, color: 0xffffff });
// const particles = new THREE.Points(particleGeometry, particleMaterial);
// scene.add(particles);

// // Обработчик событий для движения мыши
// let mouseX = 0;
// let mouseY = 0;
// let windowHalfX = window.innerWidth / 2;
// let windowHalfY = window.innerHeight / 2;

// document.addEventListener('mousemove', (event) => {
//   mouseX = event.clientX - windowHalfX;
//   mouseY = event.clientY - windowHalfY;
// });

// // Анимационный цикл
// const animate = () => {
//   requestAnimationFrame(animate);

//   // Обновление позиции частиц в зависимости от положения курсора
//   particles.position.x = (mouseX / 100) * 2;
//   particles.position.y = (mouseY / 100) * -2;

//   // Настройка размера и цвета частиц в зависимости от скорости движения мыши
//   const particleSize = Math.abs(mouseX) + Math.abs(mouseY);
//   const particleColor = new THREE.Color(Math.abs(mouseX) / window.innerWidth, Math.abs(mouseY) / window.innerHeight, 0.5);

//   particleMaterial.size = particleSize * 0.01;
//   particleMaterial.color = particleColor;

//   renderer.render(scene, camera);
// };

// animate();


}   